exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-kalkulator-jsx": () => import("./../../../src/pages/kalkulator.jsx" /* webpackChunkName: "component---src-pages-kalkulator-jsx" */),
  "component---src-pages-privatnost-jsx": () => import("./../../../src/pages/privatnost.jsx" /* webpackChunkName: "component---src-pages-privatnost-jsx" */)
}

